
  <pagination-template #p="paginationApi" [id]="id" [maxSize]="maxSize" [lang]="lang"
    (pageChange)="pageChange.emit($event)"
    (checkChange)="checkChange.emit()">
    <div class="clearfix">
      <div class="pager float-right">
        {{ p.getCurrent() }} {{ lang }} {{ p.getLastPage() }}
        <span class="prev-page" [class.off]="p.isFirstPage()" (click)="p.previous()"></span>
        <span class="next-page" [class.off]="p.isLastPage()" (click)="p.next()"></span>
      </div>
    </div>
  </pagination-template>